import React from 'react'
import HomeAboutItem from './HomeAboutItem'

const HomeAbout = ({ aboutData }) => {
  const { aboutItems, backgroundImage, details, header, slogan } = aboutData

  return (
    <section
      className="dealmed-home-about"
      aria-labelledby="dealmed-home-about-heading"
      style={{ backgroundImage: `url(${backgroundImage.fields.file.url})` }}
    >
      <div className="dealmed-container">
        <h2 className="dealmed-home-about__heading" id="dealmed-home-about-heading">
          {header}
        </h2>
        <p className="dealmed-home-about__subheading">{slogan}</p>
        <p className="dealmed-home-about__text">{details}</p>
        <ul className="dealmed-home-about__list">
          {aboutItems
            .map(item => item.fields)
            .map((item, index) => {
              return (
                <HomeAboutItem key={index} icon={item.icon} title={item.title} text={item.text} />
              )
            })}
        </ul>
      </div>
    </section>
  )
}

export default HomeAbout
